// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card .card-header-title[data-v-7ccdc702] {\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: 700;\n}", ""]);
// Exports
module.exports = exports;
